import React from 'react';
import { Link } from 'react-router-dom';

export default function PageBr() {
    return (
        <div className="page" style={{ alignItems:'center', justifyContent:'center', minHeight:'100vh' }}>
            <div style={{ textAlign:'center', padding:40 }}>
                <h2 style={{ color:'var(--color-dark)', marginBottom:30 }}>III Fórum de Finanças Climáticas e de Natureza</h2>
                <Link to="/" className="btn-send">Ir para o início</Link>
            </div>
        </div>
    );
}
